import * as React from 'react'
import { SVGProps } from 'react'
const SvgEllipseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 32 33' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx={16.151} cy={16.715} r={15.73} fill='#fff' />
  </svg>
)
export default SvgEllipseIcon
